const differentials = [
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte completo em português",
    desc: "Nossa equipe é fluente em português, seja você brasileiro, português, angolano ou de qualquer país lusófono. Aqui você sempre será atendido no seu idioma.",
    highlight: true,
  },
  {
    icon: "ri-user-star-line",
    title: "Equipe com experiência no Brasil e nos EUA",
    desc: "A contadora responsável pela ZB Advisor exerceu a profissão no Brasil e há mais de 5 anos atua como contadora nos Estados Unidos. Essa trajetória binacional é o que diferencia nossa orientação.",
    highlight: false,
  },
  {
    icon: "ri-time-line",
    title: "Atendimento humano e ágil",
    desc: "Nenhum robô, nenhuma fila de espera interminável. Você fala com uma pessoa real que entende seu problema e te ajuda a resolver rapidamente.",
    highlight: false,
  },
  {
    icon: "ri-global-line",
    title: "Time que conhece os dois lados",
    desc: "Nossa equipe de contadores trabalhou no Brasil e nos EUA, compreendendo profundamente as diferenças entre os dois sistemas — fiscal, tributário e empresarial. Esse conhecimento nos permite oferecer orientação verdadeiramente especializada.",
    highlight: false,
  },
];

const cards2 = [
  { icon: "ri-arrow-right-up-line", text: "Acesso direto a especialistas", bg: "bg-[#0f2044]", textColor: "text-white" },
  { icon: "ri-file-check-line", text: "Planos de atendimento escaláveis", bg: "bg-[#2563eb]", textColor: "text-white" },
  { icon: "ri-translate-2", text: "Suporte em português, inglês e espanhol", bg: "bg-white", textColor: "text-[#0f2044]" },
];

export default function DifferentialsSection() {
  return (
    <section id="diferenciais" className="bg-white py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div>
            <span className="text-[#2563eb] text-sm font-semibold tracking-wider uppercase">Nossos diferenciais</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0f2044] mt-2 mb-6">
              O que torna a{" "}
              <span className="text-[#2563eb]">ZB Advisor</span>{" "}
              diferente dos nossos planos
            </h2>

            <div className="space-y-6">
              {differentials.map((item, idx) => (
                <div
                  key={idx}
                  className={`flex gap-4 p-5 rounded-2xl transition-all ${
                    item.highlight ? "bg-blue-50 border border-[#2563eb]/30" : "bg-[#f5f7fc] border border-transparent"
                  }`}
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0f2044] rounded-xl flex-shrink-0">
                    <i className={`${item.icon} text-white text-lg`} />
                  </div>
                  <div>
                    <h4 className="text-[#0f2044] font-semibold text-sm mb-1">{item.title}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="space-y-5">
            {/* Image */}
            <div className="rounded-2xl overflow-hidden h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/3064f6600e31b7c6498f9a6f628bdab3.jpg"
                alt="Equipe ZB Consulting"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 gap-3">
              {cards2.map((c, i) => (
                <div
                  key={i}
                  className={`${c.bg} ${c.textColor} rounded-2xl p-4 flex items-center gap-3 border border-gray-100`}
                >
                  <div className={`w-9 h-9 flex items-center justify-center rounded-xl ${
                    c.bg === "bg-white" ? "bg-[#0f2044]" : "bg-white/20"
                  }`}>
                    <i className={`${c.icon} ${c.bg === "bg-white" ? "text-white" : ""} text-lg`} />
                  </div>
                  <p className="font-semibold text-sm">{c.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
